function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Coordinate from '../geom/Coordinate';
import DD from '../math/DD';
var CGAlgorithmsDD = /*#__PURE__*/function () {
  function CGAlgorithmsDD() {
    _classCallCheck(this, CGAlgorithmsDD);
    CGAlgorithmsDD.constructor_.apply(this, arguments);
  }
  return _createClass(CGAlgorithmsDD, [{
    key: "getClass",
    value: function getClass() {
      return CGAlgorithmsDD;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "orientationIndex",
    value: function orientationIndex(p1, p2, q) {
      var index = CGAlgorithmsDD.orientationIndexFilter(p1, p2, q);
      if (index <= 1) return index;
      var dx1 = DD.valueOf(p2.x).selfAdd(-p1.x);
      var dy1 = DD.valueOf(p2.y).selfAdd(-p1.y);
      var dx2 = DD.valueOf(q.x).selfAdd(-p2.x);
      var dy2 = DD.valueOf(q.y).selfAdd(-p2.y);
      return dx1.selfMultiply(dy2).selfSubtract(dy1.selfMultiply(dx2)).signum();
    }
  }, {
    key: "signOfDet2x2",
    value: function signOfDet2x2() {
      if (arguments[3] instanceof DD && arguments[2] instanceof DD && arguments[0] instanceof DD && arguments[1] instanceof DD) {
        var x1 = arguments[0];
        var y1 = arguments[1];
        var x2 = arguments[2];
        var y2 = arguments[3];
        var det = x1.multiply(y2).selfSubtract(y1.multiply(x2));
        return det.signum();
      } else if (typeof arguments[3] === 'number' && typeof arguments[2] === 'number' && typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        var dx1 = arguments[0];
        var dy1 = arguments[1];
        var dx2 = arguments[2];
        var dy2 = arguments[3];
        var _x = DD.valueOf(dx1);
        var _y = DD.valueOf(dy1);
        var _x2 = DD.valueOf(dx2);
        var _y2 = DD.valueOf(dy2);
        var _det = _x.multiply(_y2).selfSubtract(_y.multiply(_x2));
        return _det.signum();
      }
    }
  }, {
    key: "intersection",
    value: function intersection(p1, p2, q1, q2) {
      var denom1 = DD.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(DD.valueOf(p2.x).selfSubtract(p1.x));
      var denom2 = DD.valueOf(q2.x).selfSubtract(q1.x).selfMultiply(DD.valueOf(p2.y).selfSubtract(p1.y));
      var denom = denom1.subtract(denom2);
      var numx1 = DD.valueOf(q2.x).selfSubtract(q1.x).selfMultiply(DD.valueOf(p1.y).selfSubtract(q1.y));
      var numx2 = DD.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(DD.valueOf(p1.x).selfSubtract(q1.x));
      var numx = numx1.subtract(numx2);
      var fracP = numx.selfDivide(denom).doubleValue();
      var x = DD.valueOf(p1.x).selfAdd(DD.valueOf(p2.x).selfSubtract(p1.x).selfMultiply(fracP)).doubleValue();
      var numy1 = DD.valueOf(p2.x).selfSubtract(p1.x).selfMultiply(DD.valueOf(p1.y).selfSubtract(q1.y));
      var numy2 = DD.valueOf(p2.y).selfSubtract(p1.y).selfMultiply(DD.valueOf(p1.x).selfSubtract(q1.x));
      var numy = numy1.subtract(numy2);
      var fracQ = numy.selfDivide(denom).doubleValue();
      var y = DD.valueOf(q1.y).selfAdd(DD.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(fracQ)).doubleValue();
      return new Coordinate(x, y);
    }
  }, {
    key: "orientationIndexFilter",
    value: function orientationIndexFilter(pa, pb, pc) {
      var detsum = null;
      var detleft = (pa.x - pc.x) * (pb.y - pc.y);
      var detright = (pa.y - pc.y) * (pb.x - pc.x);
      var det = detleft - detright;
      if (detleft > 0.0) {
        if (detright <= 0.0) {
          return CGAlgorithmsDD.signum(det);
        } else {
          detsum = detleft + detright;
        }
      } else if (detleft < 0.0) {
        if (detright >= 0.0) {
          return CGAlgorithmsDD.signum(det);
        } else {
          detsum = -detleft - detright;
        }
      } else {
        return CGAlgorithmsDD.signum(det);
      }
      var errbound = CGAlgorithmsDD.DP_SAFE_EPSILON * detsum;
      if (det >= errbound || -det >= errbound) {
        return CGAlgorithmsDD.signum(det);
      }
      return 2;
    }
  }, {
    key: "signum",
    value: function signum(x) {
      if (x > 0) return 1;
      if (x < 0) return -1;
      return 0;
    }
  }]);
}();
export { CGAlgorithmsDD as default };
CGAlgorithmsDD.constructor_ = function () {};
CGAlgorithmsDD.DP_SAFE_EPSILON = 1e-15;